import script from "./listRatting.vue?vue&type=script&setup=true&lang=js"
export * from "./listRatting.vue?vue&type=script&setup=true&lang=js"

import "./listRatting.vue?vue&type=style&index=0&id=41f738e2&scoped=true&lang=scss"

import exportComponent from "E:\\project\\lms-frontend-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41f738e2"]])

export default __exports__